export const NotFound = () => {
    return(
        <h1>ErrorNotFound</h1>
    )
}